import {
  Col,
  Divider,
  Row,
  Input,
  Spin,
  Segmented,
  Tooltip,
  notification,
} from "antd";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { Button } from "react-bootstrap";
import "./Login.css";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import Countdown from "react-countdown";
import { SendOtpApi, VerifyOtpApi } from "../../Services/Login";
import { Label } from "reactstrap";
import djtLogo from "../../Assets/Images/djt-logo.png";
import loginSvg from "../../Assets/Svg/login-page-svg.svg";
import Cookies from "js-cookie";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 18, color: "white" }} spin />
);

export default function Login() {
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate(null);

  const [isOtp, setIsOtp] = useState(
    sessionStorage.getItem("isOtp") !== undefined
      ? sessionStorage.getItem("isOtp") === "true"
        ? true
        : false
      : false
  );
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");

  const [emailSpin, setEmailSpin] = useState(false);
  const [resendSpin, setResendSpin] = useState(false);
  const [otpSpin, setOtpSpin] = useState(false);

  const [emailErrorMessage, setEmailErrorMessage] = useState(null);
  const [otpErrorMessage, setOtpErrorMessage] = useState(null);

  const emailRef = useRef(null);
  const otpRef = useRef(null);

  const isValidEmail = (email) => {
    const validDomains = [
      "djtcorp.in",
      "djtretailers.com",
      "djtmpl.in",
      "indogulfhospital.com",
      "djtfintech.com",
    ];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) return false;

    const domain = email.split("@")[1];
    return validDomains.includes(domain);
  };

  const [currentDate, setCurrentDate] = useState("");
  const [countdownKey, setCountdownKey] = useState(1);
  const [loginType, setLoginType] = useState("EMPLOYEE");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailErrorMessage(null);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setOtpErrorMessage(null);
  };

  const handleSendOtp = async () => {
    try {
      setEmailSpin(true);
      const data = await SendOtpApi(email, loginType);
      setEmailSpin(false);

      if (data.data.success) {
        setIsOtp(true);
        sessionStorage.setItem("email", email);
        sessionStorage.setItem("isOtp", true);
      } else {
        setEmailErrorMessage(data.data.message);
      }
    } catch (err) {
      setEmailSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleResendOtp = async () => {
    try {
      setResendSpin(true);
      const data = await SendOtpApi(sessionStorage?.getItem("email"));
      setResendSpin(false);

      if (data.data.success) {
        setCountdownKey(countdownKey + 1);
      } else {
        setOtpErrorMessage(data.data.message);
      }
    } catch (err) {
      setResendSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setOtpSpin(true);
      const data = await VerifyOtpApi(sessionStorage?.getItem("email"), otp);
      setOtpSpin(false);

      console.log(data);

      if (data.data.success) {
        sessionStorage.removeItem("email");
        sessionStorage.setItem("isOtp", false);

        sessionStorage.setItem("firstName", data.data.data.name.first_name);
        sessionStorage.setItem("middleName", data.data.data.name.middle_name);
        sessionStorage.setItem("lastName", data.data.data.name.last_name);
        sessionStorage.setItem("fullName", data.data.data.name.full_name);

        sessionStorage.setItem("personalEmail", data.data.data.email.personal);
        sessionStorage.setItem("companyEmail", data.data.data.email.company);
        sessionStorage.setItem("userId", data.data.data._id);
        sessionStorage.setItem("authorization", data.data.data.authorization);

        sessionStorage.setItem("isLoggedIn", "true");

        if (loginType === "EMPLOYEE") {
          if (data.data.data.new_user) {
            sessionStorage.setItem("userType", "newUser");
            navigate("/new-user/personal");
          } else {
            sessionStorage.setItem("userType", "user");
            navigate("/user/dashboard");
          }
        } else {
          sessionStorage.setItem("userType", "admin");
          Cookies.set("token", data.data.data.admin_token.split(" ")[1]);
          sessionStorage.setItem(
            "token",
            `bearer ${data.data.data.admin_token.split(" ")[1]}`
          );
          navigate("/admin/employees-verification");
        }
      } else {
        setOtpErrorMessage(data.data.message);
      }
    } catch (err) {
      setOtpSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const handleChangeEmailButton = () => {
    setEmail("");
    setIsOtp(false);
    sessionStorage.setItem("email", "");
    sessionStorage.setItem("isOtp", false);
  };

  const renderer = ({ hours, minutes, seconds, completed, api, props }) => {
    if (completed) {
      // Render a completed state
      return (
        <Button
          className="resend-button mb-2 px-1"
          onClick={handleResendOtp}
          disabled={otpSpin || resendSpin}
        >
          <Spin
            className="mb-2 mr-2"
            indicator={antIcon}
            spinning={resendSpin}
          />
          Resend OTP
        </Button>
      );
    } else {
      if (seconds === 0 && minutes === 0) {
        props.date = props.date + 120000;
      }
      api.start();
      // Render a countdown
      return (
        <Button className="resend-button mb-2 px-1" disabled>
          {`Resend OTP in ${minutes > 9 ? minutes : "0" + minutes}:${
            seconds > 9 ? seconds : "0" + seconds
          }`}
        </Button>
      );
    }
  };
  return (
    <>
      {contextHolder}

      <Row className="login-header justify-content-center align-items-center py-2 px-2">
        <img src={djtLogo} width="100px" alt="DJT" />
        <Divider className="my-2" />
      </Row>

      <Row className="login-row">
        <Col
          className="login-box-first flex items-center justify-center"
          xxl={15}
          xl={16}
          lg={14}
          md={0}
          sm={0}
          xs={0}
        >
          <img
            src={loginSvg}
            alt=""
            className="w-fit h-fit"
            style={{ objectFit: "contain" }}
          />
        </Col>
        <Col
          className="login-box-second align-items-center"
          xxl={9}
          xl={8}
          lg={10}
          md={12}
          sm={18}
          xs={24}
        >
          <Col className="login-box-main">
            <div className="text-center login-header">
              <span className="custom-heading">Login</span>
            </div>
            <div className="vertical-center">
              <Segmented
                className="mb-3"
                size="large"
                options={[
                  { label: "Employee", value: "EMPLOYEE" },
                  { label: "HR", value: "ADMIN" },
                ]}
                value={loginType}
                onChange={(val) => setLoginType(val)}
                block
                disabled={isOtp || emailSpin ? true : false}
              />
              {!isOtp ? (
                <div>
                  <Row className="mb-5">
                    <Label for="email" size="lg">
                      Enter Email ID
                    </Label>
                    <Input
                      id="email"
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        isValidEmail(email) &&
                        handleSendOtp()
                      }
                      ref={emailRef}
                      type="email"
                      status=""
                      disabled={emailSpin}
                      prefix={<UserOutlined className="mr-2" />}
                      placeholder="Enter Email ID"
                      size="large"
                      onChange={(e) => handleEmailChange(e)}
                    />
                    {email.length === 0 ? (
                      <span className="text-danger email-error-message mt-1">
                        Please enter your email.
                      </span>
                    ) : !isValidEmail(email) ? (
                      <span className="text-danger email-error-message mt-1">
                        Please enter a valid @djtcorp.in, @djtretailers.com,
                        @indogulfhospital.com, @djtfintech.com, or @djtmpl.in
                        email address.
                      </span>
                    ) : emailErrorMessage !== null ? (
                      <span className="text-danger email-error-message mt-1">
                        {emailErrorMessage}
                      </span>
                    ) : null}
                  </Row>
                  <Row>
                    <Button
                      className="otp-button bg-info bg-gradient"
                      style={{ width: "100%" }}
                      onClick={handleSendOtp}
                      disabled={
                        email.length === 0 || emailSpin || !isValidEmail(email)
                      }
                    >
                      <Spin
                        className="mb-2 mr-2"
                        indicator={antIcon}
                        spinning={emailSpin}
                      />{" "}
                      Send OTP
                    </Button>
                  </Row>
                </div>
              ) : (
                <div>
                  <Row className="mb-5 position-relative">
                    <span
                      className="position-absolute end-0 text-secondary mx-2"
                      style={{ top: "30px", fontSize: "12px" }}
                    >
                      {sessionStorage.getItem("email")}
                    </span>
                    <Label for="email" size="lg">
                      Enter OTP
                    </Label>
                    <Input.Password
                      id="otp"
                      ref={otpRef}
                      onKeyDown={(e) =>
                        e.key === "Enter"
                          ? otp.length !== 0
                            ? otpRef.current.input.validity.valid
                              ? handleVerifyOtp()
                              : ""
                            : ""
                          : ""
                      }
                      type="tel"
                      maxLength={6}
                      pattern="[0-9]{6}"
                      disabled={otpSpin || resendSpin}
                      prefix={<LockOutlined className="mr-2" />}
                      placeholder="Enter OTP"
                      size="large"
                      onChange={(e) => handleOtpChange(e)}
                    />
                    {otpErrorMessage !== null ? (
                      <span className="text-danger otp-error-message mt-1">
                        {otpErrorMessage}
                      </span>
                    ) : otp.length === 0 ? (
                      <span className="text-danger otp-error-message mt-1">
                        Please enter OTP.
                      </span>
                    ) : !otpRef.current.input.validity.valid ? (
                      <span className="text-danger otp-error-message mt-1">
                        Please valid OTP.
                      </span>
                    ) : null}
                  </Row>
                  <Row className="justify-content-between">
                    <Col className="pr-2" span={12}>
                      <Tooltip
                        overlayInnerStyle={{ color: "black" }}
                        title={`Using ${sessionStorage.getItem("email")}`}
                        color="white"
                      >
                        <Button
                          className="change-email-button mb-2 bg-warning bg-gradient"
                          onClick={handleChangeEmailButton}
                          disabled={otpSpin || resendSpin}
                        >
                          Change Email
                        </Button>
                      </Tooltip>
                    </Col>
                    <Col className="pl-2" span={12}>
                      <Countdown
                        date={currentDate + 120000}
                        key={countdownKey}
                        renderer={renderer}
                        onMount={() => setCurrentDate(Date.now())}
                        lg
                      />
                    </Col>
                    <Col span={24}>
                      <Button
                        className="otp-button bg-info bg-gradient mb-2"
                        onClick={handleVerifyOtp}
                        disabled={
                          /^\d+$/.test(otp) && !otpSpin && !resendSpin
                            ? otp.length === 6
                              ? false
                              : true
                            : true
                        }
                      >
                        <Spin
                          className="mb-2 mr-2"
                          indicator={antIcon}
                          spinning={otpSpin}
                        />
                        Verify OTP
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Col>
        </Col>
      </Row>
      <div className="brand px-2">
        <Divider className="mt-0 mb-2" />
        <p className="brand-name mb-2">&#9426; Employee Connect</p>
      </div>
    </>
  );
}
